import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';

@Injectable()
export class DataLayerService {
  private window: any;

  constructor(private _windowRef: WindowReferenceService) {
    this.window = _windowRef.nativeWindow; // Initialize the window to what we get from the WindowReferenceService
  }

  /**
   * Pushes an event object to the `dataLayer`.
   * @param obj - An object containing event details.
   */
  private pingHome(obj: Record<string, any>): void {
    if (obj) {
      if (Array.isArray(this.window?.dataLayer)) {
        this.window.dataLayer.push(obj);
      } else {
        console.error('DataLayer is not defined on the window object.');
      }
    }
  }

  /**
   * Logs a page view to the `dataLayer`.
   * @param url - The URL to log as a page view.
   */
  logPageView(url: string): void {
    const hit: Record<string, any> = {
      event: 'content-view',
      pageName: url,
    };
    this.pingHome(hit);
  }

  /**
   * Logs a custom event to the `dataLayer`.
   * @param event - The event name.
   * @param category - The event category.
   * @param action - The action that triggered the event.
   * @param label - Additional details for the event.
   */
  logEvent(event: string, category: string, action: string, label: string): void {
    const hit: Record<string, any> = {
      event,
      customEventCategory: category,
      customEventAction: action,
      customEventLabel: label,
    };
    this.pingHome(hit);
  }

  /**
   * Pushes a custom event object to the `dataLayer`.
   * @param eventObj - A generic event object to push.
   */
  pushEvent(eventObj: Record<string, any>): void {
    if (typeof eventObj === 'object' && eventObj !== null) {
      this.pingHome(eventObj);
    } else {
      console.error('Invalid event object passed to pushEvent.');
    }
  }

  /**
   * Logs a custom dimension to the `dataLayer`.
   * @param value - The custom dimension value to log.
   */
  logCustomDimensionTest(value: string | number): void {
    const hit: Record<string, any> = {
      event: 'custom-dimension',
      value,
    };
    this.pingHome(hit);
  }

  // Add more custom methods as required by your app.
}
